/** @file Assets tree: images by name, each with the attachments that show it, by name. */
import { entriesByName } from '@pose2d/format/doc/entriesByName';
import type { Doc, Id } from '@pose2d/format/types';
import { ROW_BADGES as B } from '../../forms/rowBadges.data';
import type { TreeNode } from '../../ui-kit/logic/flattenTree';

/** Image rows with attachment children; region and mesh attachments carry their own badge. */
export function buildAssets(doc: Doc): TreeNode[] {
  const byImage = new Map<Id, TreeNode[]>();
  for (const [id, att] of entriesByName(doc.attachments)) {
    const node: TreeNode = { id, label: att.name, badge: att.type === 'mesh' ? B.mesh : B.region };
    byImage.set(att.image, [...(byImage.get(att.image) ?? []), node]);
  }
  return entriesByName(doc.images).map(([id, image]) => ({ id, label: image.name, badge: B.image, children: byImage.get(id) ?? [] }));
}
